<template>
  <el-row :gutter="20">
    <el-col :span="6" v-for="item in cards" :key="item.label">
      <el-card>
        <div style="font-size:14px;color:#666;">{{ item.label }}</div>
        <div style="font-size:32px;font-weight:700;margin-top:10px;">{{ item.value }}</div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { getDashboard } from '@/api'

export default {
  data () {
    return {
      cards: []
    }
  },
  async created () {
    const res = await getDashboard()
    const data = res.data
    this.cards = [
      { label: '总用户数', value: data.totalUsers || 0 },
      { label: '总记录数', value: data.totalRecords || 0 },
      { label: '待审核', value: data.pendingRecords || 0 },
      { label: '今日新增', value: data.todayRecords || 0 }
    ]
  }
}
</script>
